import useAuth from '@/hooks/useAuth';
import useUsersApi from '@/hooks/user/useUsersApi';
import React, { createContext, useContext, useEffect } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { toast } from 'react-toastify';
import { useAppContext } from './app';

const IdleContext = createContext({});

export const useIdle = () => useContext(IdleContext);

interface IIdleProviderProps {
    children: React.ReactNode;
}

const TIMEOUT = 1000 * 60 * 540; // 60*9=540  9h

export const IdleProvider: React.FC<IIdleProviderProps> = ({ children }) => {
    const [isUserLogin, setIsUserLogin] = React.useState<boolean>(false);
    const { logOut, needRefreshAuthTokens, checkAuth } = useAuth();
    const { auth, setAuthUser } = useAppContext()
    const { updateLastActivity } = useUsersApi();

    useEffect(() => {
        setIsUserLogin(!!auth?.user);
    }, [auth?.user]);

    const handleOnIdle = () => {
        toast.warning('¡Su sessión ha expirado!')
        logOut();
    };

    const handleOnAction = async () => {
        try {
            const isNeedRefreshTokens = needRefreshAuthTokens();
            isNeedRefreshTokens && await checkAuth();
            const user = await updateLastActivity();
            setAuthUser(user);
        } catch (error) {
            console.error('Error updating last activity:', error);
        }
    };

    return (
        <IdleTimerProvider
            timeout={TIMEOUT}
            onIdle={handleOnIdle}
            onAction={handleOnAction}
            disabled={!isUserLogin}
            debounce={2000}
            crossTab
        >
            <IdleContext.Provider value={{}}>
                {children}
            </IdleContext.Provider>
        </IdleTimerProvider>
    );
};